// extracted by mini-css-extract-plugin
module.exports = {"markerContainer":"ProjectMarkers_markerContainer__OyFej","marker":"ProjectMarkers_marker__Pp_3w"};